import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { useSubmitReport } from '../../../hooks/index';
import { dataModel } from '../dataModel';
import '../Voting.scss';

const Report = ({ answerId }) => {
  const [reported, setReported] = useState(false);

  const postReportData = {
    id: answerId,
    feedbacktype: 'inappropriate',
    contenttype: 'answer',
    vote: ''
  };

  const [submitReport, reportResponse] = useSubmitReport(postReportData);

  const handleReport = () => {
    submitReport();
  };

  useEffect(() => {
    if (reportResponse?.data) {
      const feedback = reportResponse?.data?.submitReviewFeedback;
      if (feedback?.Feedback?.FeedbackInappropriate) {
        setReported(true);
      }
    }
  }, [reportResponse]);

  return (
    <div className="report-container">
      {reported ? (
        <p>Thank you for submitting feedback for this answer!</p>
      ) : (
        <button className="report-button" type="button" onClick={handleReport}>
          Report
        </button>
      )}
    </div>
  );
};

Report.dataModel = dataModel;

Report.displayName = 'Report';

Report.propTypes = {
  answerId: string.isRequired
};

export { Report };
